import React from 'react';
import {
  Avatar,
  Box,
  Container,
  Divider,
  Flex,
  IconButton,
  Spacer,
  WrapItem
} from '@chakra-ui/react';
import MenuIcon from '../icons/Menu';

const Nav = () => {
  return (
    <Box background='#ffffff'>
      <Container>
        <Flex pl={1.5} pr={3} py={2} alignItems='center' m='auto'>
          <IconButton
            aria-label='Menu'
            icon={<MenuIcon />}
            colorScheme='#fff'
          />

          <Spacer />
          <WrapItem>
            <Avatar size='md' name='Kent Dodds' />
          </WrapItem>
        </Flex>
        <Divider />
      </Container>
    </Box>
  );
};

export default Nav;
